import(/* webpackMode: "eager" */ "/codebuild/output/src1006553232/src/helloero-new/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src1006553232/src/helloero-new/node_modules/next/dist/client/link.js");
